import { createSlice } from "@reduxjs/toolkit";
import { archiveUser, deleteInvitedUser, getInviteUserList, sendUserInvite } from "./_manageUserAction";


interface ManageUserState {
  userList: any[];
  loading: boolean;
  error: string | null;
  inviteSuccess: boolean;
}

const initialState: ManageUserState = {
  userList: [],
  loading: false,
  error: null,
  inviteSuccess: false,
};


export const manageUserReducer = createSlice({
  name: "manageUser",
  initialState: initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetInviteSuccess: (state) => {
      state.inviteSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Invite User List
      .addCase(getInviteUserList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInviteUserList.fulfilled, (state, action) => {
        state.loading = false;
        state.userList = action.payload;
      })
      .addCase(getInviteUserList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Send User Invite
      .addCase(sendUserInvite.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.inviteSuccess = false;
      })
      .addCase(sendUserInvite.fulfilled, (state, action) => {
        state.loading = false;
        state.inviteSuccess = true;
        state.userList = [...state.userList, action.payload];
      })
      .addCase(sendUserInvite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Archive User
      // .addCase(archiveUser.fulfilled, (state, action) => {
      //   state.userList = state.userList.filter((user) => user.uuid !== action.payload?.data?.uuid);
      // })
      // .addCase(archiveUser.rejected, (state, action) => {
      //   state.error = action.payload as string;
      // })
      // Delete User
      .addCase(deleteInvitedUser.fulfilled, (state, action) => {
        console.log('action.payload ========= ', action.payload);
        
        state.userList = state.userList.filter((user) => user.uuid !== action.payload?.data?.uuid);
      })
      .addCase(deleteInvitedUser.rejected, (state, action) => {
        state.error = action.payload as string;
      })
  },

});


export const { clearError, resetInviteSuccess } = manageUserReducer.actions;
export default manageUserReducer;